import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { PopFeatureFlagsDto } from '@shared/services/models/pop-feature-flags.dto';
import { PopSettingService } from '@shared/services/pop-settings.service';

@Directive({
  selector: '[popFeature]'
})
export class FeatureDirective implements OnInit {
  private featureKey: keyof PopFeatureFlagsDto;

  @Input()
  set popFeature(featureKey: keyof PopFeatureFlagsDto) {
    this.featureKey = featureKey;
  }

  public constructor(
    private templateRef: TemplateRef<unknown>,
    private container: ViewContainerRef,
    private settingsService: PopSettingService
  ) {}

  public async ngOnInit() {
    let hide = false;
    if (this.featureKey) {
      hide = await this.settingsService.getFeatureFlagValue(this.featureKey);
    }

    if (hide) {
      this.container.clear();
      return;
    }
    this.container.createEmbeddedView(this.templateRef);
  }
}
